var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "custom-multiselect-style placeholder-italic",
      class: _vm.hoverCustomClass,
    },
    [
      _c(
        "multiselect",
        {
          ref: _vm.cref,
          class: _vm.classObject,
          attrs: {
            "track-by": _vm.trackBy,
            value: _vm.selectedItems,
            label: _vm.options.name,
            placeholder: _vm.placeholder,
            "custom-label": _vm.customLabel,
            options: _vm.options,
            "clear-on-select": false,
            "select-label": _vm.selectLabel,
            "deselect-label": _vm.deselectLabel,
            "close-on-select": _vm.closeOnSelect,
            "hide-selected": _vm.multiple,
            "internal-search": false,
            "options-limit": 300,
            limit: _vm.max || 2,
            multiple: _vm.multiple,
            searchable: _vm.searchable,
            showNoResults: _vm.showNoResults,
            "limit-text": _vm.customLimitText,
            max: _vm.max,
            disabled: _vm.disabled,
            "group-label": _vm.groupLabel,
            "group-values": _vm.groupValues,
            "group-select": _vm.groupSelect,
          },
          on: {
            input: _vm.update,
            "search-change": _vm.asyncFind,
            close: function ($event) {
              return _vm.$emit("close")
            },
          },
          scopedSlots: _vm._u(
            [
              {
                key: "singleLabel",
                fn: function ({ option }) {
                  return [_vm._t("singleLabel", null, { option: option })]
                },
              },
              {
                key: "option",
                fn: function ({ option }) {
                  return [_vm._t("option", null, { option: option })]
                },
              },
              {
                key: "tag",
                fn: function ({ option, remove }) {
                  return [
                    _vm._t(
                      "tag",
                      function () {
                        return [
                          _c("MultiselectTag", {
                            attrs: {
                              option: option,
                              pillsColor: _vm.pillsColor,
                              tagMaxWidth: _vm.tagMaxWidth,
                            },
                            on: { remove: remove },
                          }),
                        ]
                      },
                      { option: option, remove: remove }
                    ),
                  ]
                },
              },
            ],
            null,
            true
          ),
        },
        [
          _c("span", { attrs: { slot: "noOptions" }, slot: "noOptions" }, [
            _vm._v(_vm._s(_vm.noOptionsText)),
          ]),
          _c(
            "span",
            {
              staticClass: "flex justify-center w-full",
              attrs: { slot: "noResult" },
              slot: "noResult",
            },
            [
              _vm.loading
                ? _c("Spinner", {
                    staticClass: "self-center -my-1",
                    attrs: { size: "sm" },
                  })
                : _c(
                    "span",
                    { staticClass: "self-start w-full cursor-default" },
                    [
                      _vm._t("noResult", function () {
                        return [_c("span", [_vm._v(_vm._s(_vm.noResultsText))])]
                      }),
                    ],
                    2
                  ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }